const CountSkeleton = () => (
  <>
    <style>{`@keyframes skeleton-loading { from { opacity: 1; } to { opacity: 0.45; } }`}</style>
    <div
      style={{
        height: 32,
        width: 55,
        margin: '0 auto',
        borderRadius: 4,
        background: '#e3e9f2',
        display: 'inline-block',
        animation: 'skeleton-loading 1.2s infinite linear alternate',
      }}
    />
  </>
);

export default CountSkeleton;
